import { useEffect, useState } from "react";
import type { AckResult } from "@mk/shared";
import { useDuelStore } from "../features/duel/duelStore.ts";
import { errorMessage, errors } from "../i18n/index.ts";
import { getSocket } from "../lib/socket.ts";
import { messages } from "../i18n/index.ts";

/**
 * Rövanş teklifi bildirimi — her ekranda görünür.
 *
 * Teklif soketten oturum boyunca dinleniyor ama sonuç paneli kapatılmışsa
 * kullanıcı ana ekranda oluyor ve teklifi hiç göremiyordu: rakip "istek
 * gönderildi" yazısına bakarken teklif sessizce süresi dolup düşüyordu.
 * Sonuç paneli açıkken bu şerit çizilmez, teklif orada zaten görünüyor.
 */
export function RematchBanner() {
  const offer = useDuelStore((s) => s.rematchOffer);
  const phase = useDuelStore((s) => s.phase);
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (!offer) return;
    const tick = () => setLeft(Math.max(0, Math.ceil((offer.expiresAt - Date.now()) / 1000)));
    tick();
    const id = window.setInterval(tick, 500);
    return () => window.clearInterval(id);
  }, [offer]);

  if (!offer || phase === "over") return null;

  function respond(accept: boolean) {
    const current = useDuelStore.getState().rematchOffer;
    if (!current) return;
    useDuelStore.getState().clearRematchOffer();
    getSocket().emit(
      "rematch:respond",
      { matchId: current.matchId, accept },
      (res: AckResult<{ ok: true }>) => {
        if (!res?.ok) {
          useDuelStore.setState({
            rematchNotice: res ? errorMessage(res) : errors.rematch_response_failed(),
          });
        }
      },
    );
  }

  return (
    <div className="rematch-banner" role="alert">
      <span className="rematch-banner__text">
        {messages.rematch.request(offer.from.username)}
        <span className="rematch-banner__timer">{messages.rematch.seconds(left)}</span>
      </span>
      <span className="flex gap-1.5">
        <button type="button" className="chip-btn" onClick={() => respond(false)}>
          {messages.rematch.decline}
        </button>
        <button type="button" className="chip-btn chip-btn--duel" onClick={() => respond(true)}>
          {messages.rematch.accept}
        </button>
      </span>
    </div>
  );
}
